import { LegalEntitiesGrid } from "./LegalEntitiesGrid";
import React, { useState } from "react";
import * as api from "../../../../api/generated-api";
import {
  createDealLegalEntityForDealAndDealInvestor,
  updateDealLegalEntityForDealAndDealInvestor,
} from "../../../../api/deals/deallegalentities";

type LegalEntitiesGridWrapperProps = {
  orgId: number;
  dealId: number;
  dealInvestorId: number;
  canEditInvestorInfo: boolean;
  investmentDealLegalEntities: api.DealLegalEntity[];
  setInvestmentDealLegalEntities: (
    fetchedInvestmentDealLegalEntities: api.DealLegalEntity[]
  ) => void;
  fetchDealLegalEntityInvestments: (investorId: number) => void;
};

export const LegalEntitiesGridWrapper = (
  props: LegalEntitiesGridWrapperProps
) => {
  const {
    orgId,
    dealId,
    dealInvestorId,
    canEditInvestorInfo,
    investmentDealLegalEntities,
    setInvestmentDealLegalEntities,
    fetchDealLegalEntityInvestments,
  } = props;

  const [
    investmentDealLegalEntitiesEditIndex,
    setInvestmentDealLegalEntitiesEditIndex,
  ] = useState<number>();

  const handleCancelForLegalEntities = () => {
    setInvestmentDealLegalEntitiesEditIndex(undefined);
    fetchDealLegalEntityInvestments(dealInvestorId);
  };

  const handleEditForLegalEntities = (index: number) => {
    setInvestmentDealLegalEntitiesEditIndex(index);
  };

  const handleAddForLegalEntities = () => {
    const newItem: api.DealLegalEntity = {
      createdAt: undefined,
      dealId: dealId,
      id: undefined,
      isCompany: false,
      isInvestor: true,
      isLawFirm: false,
      legalEntityType: api.LegalEntityType.Investor_Investment,
      name: undefined,
      organizationId: orgId,
      legalEntityOrganizationId: undefined,
      person: undefined,
      personId: undefined,
      updatedAt: undefined,
    };
    const newRows = [...investmentDealLegalEntities, newItem];
    setInvestmentDealLegalEntities(newRows);
    setInvestmentDealLegalEntitiesEditIndex(newRows.length - 1);
  };
  const handleSaveForLegalEntities = (item: api.DealLegalEntity) => {
    if (item.id == undefined) {
      createDealLegalEntityForDealAndDealInvestor(
        orgId,
        dealId,
        dealInvestorId,
        {
          legalEntityType: api.LegalEntityType.Investor_Investment,
          name: item.name,
        },
        () => {
          fetchDealLegalEntityInvestments(dealInvestorId);
        }
      );
    } else {
      updateDealLegalEntityForDealAndDealInvestor(
        orgId,
        dealId,
        dealInvestorId,
        item.id,
        {
          name: item.name,
        },
        () => {
          fetchDealLegalEntityInvestments(dealInvestorId);
        }
      );
    }

    setInvestmentDealLegalEntitiesEditIndex(undefined);
  };

  return (
    <LegalEntitiesGrid
      items={investmentDealLegalEntities}
      editRowIndex={investmentDealLegalEntitiesEditIndex}
      canEditInvestorInfo={canEditInvestorInfo}
      onEdit={handleEditForLegalEntities}
      onCancel={handleCancelForLegalEntities}
      onAdd={handleAddForLegalEntities}
      onSave={handleSaveForLegalEntities}
    />
  );
};
